import { Injectable } from '@angular/core';
import { Http, Wrapper } from '@skylab-angular-shared/core';
import { DocumentKsefStatusNotificatorBase } from '@skylab-shared/business';
import { EventNotificationsService } from '../event-notifications.service';

@Injectable({ providedIn: 'root'})
@Wrapper(DocumentKsefStatusNotificatorBase)
export class DocumentKsefStatusNotificator {
    public constructor(
        eventNortifications: EventNotificationsService,
        http: Http
    ) { }
}
